import PageNav from "@/components/PageNav/PageNav.vue";
import Footer from "@/components/Footer/footer.vue";
import currencyApi from '@/common/api/currency.js';

const MARKET_REFRESH_INTERVAL = 15000;

export default {
    components: {
        Footer,
        PageNav
    },
    data() {
        return {
            tabOptions: [
                'rank.gainers',
                'rank.losers',
                'rank.new',
                'rank.volume'
            ],
            tabIndex: 0,
            priceGroup: [
                'rank.all_price',
                'rank.price_below_half_dollar',
                'rank.price_half_to_one_dollar',
                'rank.price_one_to_ten_dollars',
                'rank.price_ten_to_one_hundred_dollars',
                'rank.price_above_one_hundred_dollars'
            ],
            market: [
                'rank.all_market',
                'rank.market_cap_below_one_hundred_million',
                'rank.market_cap_one_hundred_million_to_one_billion',
                'rank.market_cap_one_to_five_billion',
                'rank.market_cap_five_to_ten_billion',
                'rank.market_cap_above_fifty_billion'
            ],
            increase: [
                'rank.change_today',
                'rank.five_minute_change',
                'rank.one_hour_change',
                'rank.change_week',
                'rank.change_month'
            ],
            priceVal: 'rank.all_price',
            marketVal: 'rank.all_market',
            increaseVal: 'rank.change_today',
            pricesort: 1,
            marketsort: 1,
            increasesort: 1,
            // 真实数据
            currencyList: [],
            allCurrency: [],
            lastUpdateTime: 0,
            updateTimer: null,
            marketRefreshInFlight: false
        }
    },
    async created() {
        this.priceVal = this.priceGroup[0]
        this.marketVal = this.market[0]
        this.increaseVal = this.increase[0]
        
        // 加载真实数据
        await this.getTradesCurrency();
        
        this.startMarketRefresh();
    },
    beforeUnmount() {
        // 清理定时器
        if (this.updateTimer) {
            clearInterval(this.updateTimer);
            this.updateTimer = null;
        }
    },
    methods: {
        // 获取币种数据
        async getTradesCurrency() {
            if (this.marketRefreshInFlight) {
                return;
            }

            this.marketRefreshInFlight = true;
            try {
                const res = await currencyApi.tradeCurrencyList();
                let currencies = [];
                
                if (res && res.code === 200 && res.data && res.data[0] && res.data[0].currency) {
                    currencies = res.data[0].currency;
                } else {
                    console.error('❌ 排行榜API数据格式错误:', res);
                    // 如果API数据格式不对，尝试直接使用res.data
                    if (res && res.data && Array.isArray(res.data) && res.data.length > 0) {
                        currencies = res.data;
                    }
                }

                if (currencies.length > 0) {
                    this.updateCurrencyList(currencies);
                }
            } catch (error) {
                console.error('❌ 排行榜获取币种数据失败:', error);
            } finally {
                this.marketRefreshInFlight = false;
            }
        },

        updateCurrencyList(currencies) {
            const nextCurrencies = currencies.slice(0, 50);
            const latestById = new Map(
                nextCurrencies.map((currency) => [String(currency.id), currency])
            );

            this.allCurrency = nextCurrencies;
            this.currencyList = this.currencyList.length === 0
                ? [...nextCurrencies]
                : this.currencyList.map((currency) => {
                    const latestCurrency = latestById.get(String(currency.id));
                    return latestCurrency ? {...currency, ...latestCurrency} : currency;
                });
            this.lastUpdateTime = Date.now();
        },

        startMarketRefresh() {
            if (this.updateTimer) {
                clearInterval(this.updateTimer);
            }

            this.updateTimer = setInterval(() => {
                if (typeof document !== 'undefined' && document.hidden) {
                    return;
                }
                this.getTradesCurrency();
            }, MARKET_REFRESH_INTERVAL);
        },

        // 排序方法
        priceSort() {
            switch (this.pricesort) {
                case 1:
                    this.pricesort = 2;
                    // 价格升序
                    this.currencyList.sort((a, b) => a.new_price - b.new_price);
                    break;
                case 2:
                    this.pricesort = 3;
                    // 价格降序
                    this.currencyList.sort((a, b) => b.new_price - a.new_price);
                    break;
                case 3:
                    this.pricesort = 1;
                    // 恢复原序
                    this.currencyList = [...this.allCurrency];
                    break;
            }
        },

        // 跳转到现货交易页面
        goToTrade(currency) {
            if (!currency || !currency.symbol) {
                console.warn('⚠️ 币种信息不完整，无法跳转');
                return;
            }
            
            console.log('🎯 跳转到现货交易:', currency.symbol);
            
            // 跳转到现货交易页面，并传递币种信息
            this.$router.push({
                path: '/spot',
                query: {
                    symbol: currency.symbol,
                    currency_id: currency.id,
                    currency_name: currency.currency_name || currency.symbol
                }
            });
        },

        // 切换标签
        switchTab(index) {
            this.tabIndex = index;
            switch (index) {
                case 0: // 涨幅榜
                    this.currencyList = [...this.allCurrency].sort((a, b) => b.change_rate - a.change_rate);
                    break;
                case 1: // 跌幅榜
                    this.currencyList = [...this.allCurrency].sort((a, b) => a.change_rate - b.change_rate);
                    break;
                case 2: // 新币榜
                    this.currencyList = [...this.allCurrency];
                    break;
                case 3: // 成交额榜
                    this.currencyList = [...this.allCurrency].sort((a, b) => (b.quota || 0) - (a.quota || 0));
                    break;
            }
        }
    }
}
